/* Svensk katalog for locale-autopilot-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.review.completed': 'Kontrollerad / godkänd',
  'ap.review.reviewApproved': 'Kontroll godkänd',
  'ap.review.approvedNotBooked': 'Godkänd · väntar på bokföring',
  'ap.review.booked': 'Bokförd',
  'ap.review.checked': 'Kontrollerad',
  'ap.review.queueError': 'Uppgiftskön kunde inte uppdateras. Översikten kan vara ofullständig. Försök igen innan du hanterar förslag.',
  'ap.review.retry': 'Försök igen',
  'ap.review.overduePeriods': '{{count}} tidsfrister har passerats',
  'ap.review.overduePeriod': '1 tidsfrist har passerats',
  'ap.review.overdueDetails': 'Förfallna uppföljningspunkter: {{count}}. Inlämning: {{submissions}}. Betalning: {{payments}}.',
  'ap.review.deadlinePoints': '{{overdue}} förfallna och {{upcoming}} kommande uppföljningspunkter',
  'ap.review.missingStatements': 'Kontoutdrag saknas',
  'ap.review.missingStatementsPeriod': 'De här kontona saknar kontoutdrag för {{period}}.',
  'ap.monthControl.liveTitle': 'Löpande månad',
  'ap.monthControl.liveBlockedReason': 'Månaden pågår. Du kan hantera och godkänna rader löpande, men slutförandet blir tillgängligt efter månadsskiftet.',
  'ap.cancelEntry': 'Makulera kontering',
  'ap.saveEntry': 'Spara kontering',
  'ap.suggestion': 'SuperPlummas förslag',
  'ap.amountIncVat': 'Belopp (inkl. moms)',
  'ap.saveCorrection': 'Spara korrigering',
  'ap.correct': 'Korrigera',
  'ap.openInPayroll': 'Öppna i lön',
  'ap.payrollLines': 'Lönerader',
  'ap.hoursCount': 'Antal timmar',
  'ap.hourlyRate': 'Timpris',
  'ap.monthlyGross': 'Månadslön (brutto)',
  'ap.holidayPayAccrued': 'Semesterersättning avsatt (12 %)',
  'ap.employerCosts': 'Arbetsgivarens kostnader',
  'ap.employerContribution': 'Arbetsgivaravgift (14,1 %)',
  'ap.mandatoryPension': 'Obligatorisk tjänstepension (2 %)',
  'ap.approveAndFile': 'Godkänn och skicka in',
  'ap.vatReturnTitle': 'Momsdeklaration',
  'ap.post': 'Post',
  'ap.checkPost': 'Kontrollera post',
  'ap.allPostsChecked': 'Alla poster är kontrollerade.',
  'ap.registerAsset': 'Registrera tillgång',
  'ap.backToAssets': 'Tillbaka till tillgångar',
  'ap.confirmAsset': 'Bekräfta tillgång',
  'ap.registeredAutomatically': 'Registrerad automatiskt',
  'ap.balanceGroup': 'Saldogrupp',
  'ap.amountExVat': 'Belopp (exkl. moms)',
  'ap.registeredFrom': 'Registrerad från',
  'ap.registeredAssets': 'Registrerade tillgångar',
  'ap.approveRegistrations': 'Godkänn registreringar',
  'ap.saveAllAndApprove': 'Spara alla och godkänn',
  'ap.skip': 'Hoppa över',
  'ap.skipped': 'Överhoppad',
  'ap.amountIncVatShort': 'Belopp inkl. moms',
  'ap.openVoucherFull': 'Öppna verifikationen i full storlek',
  'ap.security': 'Säkerhet',
  'ap.dragVoucherHere': 'Dra en verifikation från inkorgen hit',
  'ap.approve': 'Godkänn',
  'ap.dragVoucherOntoLine': 'Dra en verifikation till raden du vill koppla den till.',
  'ap.approveTask': 'Godkänn uppgift',
  'ap.sent': 'Skickad',
  'ap.sentCount': '{{count}} skickade',
  'ap.openVatReturn': 'Öppna MVA-meldingen',
  'ap.openTask': 'Öppna uppgift',
  'ap.reopenTask': 'Ångra godkännande',
  'ap.rerun': 'Gå igenom på nytt',
  'ap.rerunHelp': 'Hämtar kön från Functions på nytt och bygger om agentlistan. Inget bokförs eller godkänns.',
  'ap.rerunDone': 'AI Redovisningskonsult har gått igenom {{month}} på nytt.',
  'ap.rerunFailed': 'Kunde inte köra genomgången på nytt.',
  'ap.staleApproval': 'Godkänd {{date}} · underlaget har ändrats sedan dess',
  'ap.bankConnection': 'Bankanslutning',
  'ap.agent.invoice.title': '{{count}} faktura(or) har inte skickats',
  'ap.agent.invoice.titleDone': 'Alla fakturor har skickats',
  'ap.agent.invoice.desc': '{{drafts}} är utkast och {{unsent}} är klara men inte skickade.',
  'ap.agent.invoice.descDone': 'Inga utkast eller oskickade fakturor under {{year}}.',
  'ap.agent.invoice.detail': 'Ett utkast är varken intäktsfört eller skickat till kunden. Skickande och bokföring görs från fakturalistan.',
  'ap.agent.invoice.action': 'Öppna fakturalistan',
  'ap.agent.invoice.lineDraft': 'Utkast · inte intäktsfört',
  'ap.agent.invoice.lineUnsent': 'Klar, men inte skickad',
  'ap.agent.invoice.execute': 'Skicka {{count}} fakturor',
  'ap.agent.invoice.choose': 'Välj fakturor',
  'ap.agent.invoice.selectAll': 'Välj alla som kan skickas',
  'ap.agent.invoice.selectRow': 'Välj faktura',
  'ap.agent.invoice.selectedCount': '{{count}} valda',
  'ap.agent.invoice.sendableCount': '{{count}} kan skickas',
  'ap.agent.invoice.finishDraftFirst': 'Utkast måste färdigställas innan de kan skickas',
  'ap.agent.invoice.sendSelectedOne': 'Skicka vald faktura',
  'ap.agent.invoice.sendSelected': 'Skicka {{count}} valda fakturor',
  'ap.agent.invoice.executeDone': 'fakturor skickade',
  'ap.agent.dunning.title': '{{count}} förfallna faktura(or) väntar på påminnelse',
  'ap.agent.dunning.titleDone': 'Inga förfallna fakturor',
  'ap.agent.dunning.desc': '{{amount}} kr är obetalt efter förfallodatum.',
  'ap.agent.dunning.descDone': 'Alla skickade fakturor är inom förfallodatum eller betalda.',
  'ap.agent.dunning.detail': 'Påminnelser, påminnelseavgift och dröjsmålsränta skickas från fakturalistan. AI Redovisningskonsult skickar ingenting själv.',
  'ap.agent.dunning.action': 'Öppna fakturalistan',
  'ap.agent.dunning.line': 'Förföll för {{days}} dag(ar) sedan · faktura {{num}}',
  'ap.agent.dunning.execute': 'Skicka {{count}} påminnelser',
  'ap.agent.dunning.executeTitle': 'Skicka betalningspåminnelser',
  'ap.agent.dunning.executeWarn': 'Påminnelserna går direkt till kunderna och kan inte dras tillbaka. Kunder som nyss har betalat utan att betalningen har registrerats får också en.',
  'ap.agent.dunning.executeNote': 'Plumme skickar inte påminnelse om samma faktura oftare än var sjunde dag och hoppar över fakturor som är reglerade eller saknar kundens e-post.',
  'ap.agent.dunning.executeDone': 'påminnelser skickade',
  'ap.agent.inbox.title': '{{count}} verifikation(er) i inkorgen är inte bokförda',
  'ap.agent.inbox.titleDone': 'Inkorgen är tom',
  'ap.agent.inbox.desc': '{{ready}} är redo att bokföras och {{review}} måste kontrolleras.',
  'ap.agent.inbox.descAnalyzing': '{{count}} verifikation(er) läses fortfarande.',
  'ap.agent.inbox.descDone': 'Inga verifikationer väntar på hantering.',
  'ap.agent.inbox.detail': 'Verifikationer läses automatiskt när de kommer in. Bokföring och kontoval godkänns i inkorgen.',
  'ap.agent.inbox.action': 'Öppna inkorgen',
  'ap.agent.inbox.execute': 'Bokför {{count}} klara verifikationer',
  'ap.agent.inbox.executeDone': 'verifikationer bokförda',
  'ap.agent.inbox.voucher': 'Verifikation',
  'ap.agent.inbox.lineReady': 'Läst och redo att bokföras',
  'ap.agent.inbox.lineReview': 'Måste kontrolleras före bokföring',
  'ap.agent.reconcile.title': '{{count}} månad(er) är inte avstämda',
  'ap.agent.reconcile.titleDone': 'Alla avslutade månader är avstämda',
  'ap.agent.reconcile.descEarly': 'Inga månader har avslutats under {{year}} ännu.',
  'ap.agent.reconcile.desc': '{{closed}} av {{total}} avslutade månader är avstämda och bokförda.',
  'ap.agent.reconcile.descDone': 'Företagskontot är avstämt till och med förra månaden.',
  'ap.agent.reconcile.detail': 'En månad räknas som avstämd när kontoutdraget för företagskontot är bokfört och arkiverat i Bank. Avstämning måste göras i kronologisk ordning.',
  'ap.agent.reconcile.action': 'Öppna bank',
  'ap.agent.reconcile.titleBlockedOrder': '{{month}} måste stämmas av först',
  'ap.agent.reconcile.descBlockedOrder': 'Avstämningen görs kronologiskt. Ingående saldo hämtas från föregående månad, så en avvikelse där skulle bli osynlig här.',
  'ap.agent.reconcile.detailBlockedOrder': 'Gå till Bank och slutför den äldsta oavstämda perioden. Då öppnas den här månaden automatiskt.',
  'ap.agent.reconcile.reasonBlockedOrder': 'Väntar på {{month}}',
  'ap.agent.reconcile.line': 'Inget avstämt kontoutdrag för företagskontot',
  'ap.agent.quality.title': '{{count}} fynd i kvalitetskontrollen',
  'ap.agent.quality.titleDone': 'Inga fynd i kvalitetskontrollen',
  'ap.agent.quality.desc': '{{missing}} köp saknar verifikation och {{duplicates}} kan vara bokförda två gånger.',
  'ap.agent.quality.descDone': 'Alla köp under {{year}} har verifikation och inga möjliga dubbelbokningar har hittats.',
  'ap.agent.quality.detailVat': 'Köp utan verifikation står för {{vat}} kr i momsavdrag som kan underkännas vid en kontroll.',
  'ap.agent.quality.detail': 'Möjliga dubbelbokningar är köp med samma leverantör, belopp och datum. De måste bedömas manuellt innan något makuleras.',
  'ap.agent.quality.action': 'Öppna transaktioner',
  'ap.agent.quality.purchase': 'Köp',
  'ap.agent.quality.lineDuplicate': '{{count}} konteringar med samma leverantör, belopp och datum',
  'ap.agent.quality.lineMissing': 'Saknar verifikation · öppna köpet för att ladda upp eller koppla dokumentation',
  'ap.agent.deadline.titleOverdue': '{{count}} deadline(s) har passerats',
  'ap.agent.deadline.title': '{{count}} deadline(s) närmar sig',
  'ap.agent.deadline.titleDone': 'Inga deadlines de närmaste 30 dagarna',
  'ap.agent.deadline.desc': 'Närmaste deadline är {{name}} {{date}}.',
  'ap.agent.deadline.descOverdue': '{{count}} förfallen inlämning är inte åtgärdad.',
  'ap.agent.deadline.descDone': 'Alla inlämningar med deadline inom 30 dagar är inlämnade.',
  'ap.agent.deadline.lineNotFiled': 'Förfallen · inte inlämnad',
  'ap.agent.deadline.lineNotPaid': 'Förfallen · inte markerad som betald',
  'ap.agent.deadline.detail': 'Deadlines följer företagets momsperiod och bolagsform. Inlämning görs från Inlämningar.',
  'ap.agent.deadline.action': 'Öppna inlämningar',
  'ap.agent.deadline.lineOverdue': 'Passerad med {{days}} dag(ar)',
  'ap.agent.deadline.line': '{{days}} dag(ar) kvar',
  'ap.agent.annualDeadline.subjectMany': '{{count}} inlämningar',
  'ap.agent.annualDeadline.titleDone': 'Deadlines i {{month}} är åtgärdade',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} är inte inlämnad — deadline har passerats',
  'ap.agent.annualDeadline.title': '{{subject}} har deadline i {{month}}',
  'ap.agent.annualDeadline.desc': '{{name}} för {{year}} har deadline {{date}}.',
  'ap.agent.annualDeadline.descDone': 'Alla inlämningar med deadline i {{month}} är markerade som inlämnade.',
  'ap.agent.annualDeadline.detail': 'Deadline ligger året efter inkomståret, så detta gäller bokföringen för {{year}} — inte {{calendarYear}}. Raden blockerar inte godkännandet av månaden.',
  'ap.agent.annualDeadline.action': 'Öppna',
  'ap.agent.annualDeadline.lineFiled': 'Markerad som inlämnad',
  'ap.agent.annualDeadline.execute': 'Markera som inlämnad utanför Plumme',
  'ap.agent.annualDeadline.executeTitle': 'Markera aksjonærregisteroppgaven som inlämnad',
  'ap.agent.annualDeadline.executeWarn': 'Plumme skickar ingenting. Detta noterar bara att uppgiften har lämnats någon annanstans, så att deadline slutar påminna.',
  'ap.agent.annualDeadline.executeNote': 'Aksjonærregisteroppgaven (RF-1086) lämnas från ett slutanvändarsystem eller Altinn. Bostadsaktiebolag är undantagna, och bolag där Euronext VPS lämnar på bolagets vägnar ska inte lämna själva.',
  'ap.agent.annualDeadline.executeDone': 'markerad',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} måste hanteras i årsarbetsflödet.',
  'ap.agent.mileage.title': '{{count}} resor i körjournalen saknar dokumentation',
  'ap.agent.mileage.titleOk': '{{count}} resor i körjournalen är dokumenterade',
  'ap.agent.mileage.titleEmpty': 'Ingen körning registrerad {{year}}',
  'ap.agent.mileage.desc': 'Körjournalen ger {{amount}} kr i avdrag {{year}}.',
  'ap.agent.mileage.descEmpty': 'Tjänsteresor ger avdrag, men bara när resorna är förda med datum, sträcka, syfte och kilometer.',
  'ap.agent.mileage.detail': 'En körjournal måste visa datum, från och till, syfte och antal kilometer för varje resa. Resor utan detta kan underkännas.',
  'ap.agent.mileage.action': 'Öppna körjournal',
  'ap.agent.mileage.trip': 'Resa utan sträcka',
  'ap.agent.mileage.lineNoPurpose': 'Saknar syfte',
  'ap.agent.mileage.lineNoKm': 'Saknar kilometer',
  'ap.agent.mileage.lineNoRoute': 'Saknar sträcka',
  'ap.agent.match.title': '{{count}} bankrader saknar verifikation',
  'ap.agent.match.titleDone': 'Alla bankrader har verifikation',
  'ap.agent.match.desc': '{{count}} verifikationer ligger i inkorgen och kan passa.',
  'ap.agent.match.descDone': 'Inga bankrader saknar dokumentation.',
  'ap.agent.match.detail': 'En verifikation kopplas automatiskt bara när den passar en bankrad och bankraden passar en verifikation. Vid tvekan måste du välja själv.',
  'ap.agent.match.action': 'Öppna bank',
  'ap.agent.match.line': 'Saknar verifikation',
  'ap.agent.match.execute': 'Koppla verifikationer automatiskt',
  'ap.agent.match.executeTitle': 'Koppla verifikationer mot bankrader',
  'ap.agent.match.executeWarn': 'Verifikationerna kopplas som dokumentation till bankraderna. Ingenting bokförs — det sker först när du stämmer av kontoutdraget.',
  'ap.agent.match.executeNote': 'Bara entydiga träffar kopplas: verifikationen måste passa en bankrad, och bankraden en verifikation. Allt annat lämnas för manuellt val.',
  'ap.agent.match.executeDone': 'verifikationer kopplade',
  'ap.agent.contacts.supplier': 'leverantörer',
  'ap.agent.contacts.customer': 'kunder',
  'ap.agent.contacts.title': 'Upp till {{count}} {{noun}} saknas i registret',
  'ap.agent.contacts.titleDone': 'Alla {{noun}} är registrerade',
  'ap.agent.contacts.desc': 'Namn som återkommer i bokföringen utan att finnas i registret.',
  'ap.agent.contacts.descDone': 'Inga återkommande namn utanför registret.',
  'ap.agent.contacts.detail': 'Bara namn och organisationsnummer skapas. E-post, telefon och adress måste du fylla i själv — Plumme gissar inte kontaktuppgifter som kan hamna på en faktura.',
  'ap.agent.contacts.openSuppliers': 'Öppna leverantörer',
  'ap.agent.contacts.openCustomers': 'Öppna kunder',
  'ap.agent.contacts.line': '{{count}} poster',
  'ap.agent.contacts.execute': 'Skapa saknade {{noun}}',
  'ap.agent.contacts.executeTitle': 'Skapa {{noun}} i registret',
  'ap.agent.contacts.executeWarn': 'Namnen skapas i registret. Befintliga poster kopplas inte automatiskt — det gör du när du öppnar posten.',
  'ap.agent.contacts.executeNote': 'Plumme skapar bara namn som återkommer minst två gånger, och hoppar över betalningstext som ”Visa” och ”Vipps”.',
  'ap.agent.contacts.executeDone': 'skapade',
  'ap.contact.supplierNumber': 'Leverantörsnr',
  'ap.contact.supplierNumberPh': 'T.ex. 20001',
  'ap.contact.supplierName': 'Leverantörsnamn',
  'ap.contact.customerName': 'Kundnamn',
  'ap.contact.namePh': 'Namn',
  'ap.contact.customerNamePh': 'T.ex. Exempel AS',
  'ap.contact.org': 'Org.nummer',
  'ap.contact.orgOptional': 'Org.nummer (valfritt)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'faktura@leverandor.no',
  'ap.contact.customerEmailPh': 'post@eksempel.no',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Adress',
  'ap.contact.addressPh': 'Gatuadress',
  'ap.contact.supplierAddressPh': 'Gatuadress, postnummer och ort',
  'ap.agent.tax.titleBlocked': 'Skatteunderlaget är inte tillgängligt',
  'ap.agent.tax.descBlocked': 'Bokföringssiffrorna för {{year}} är inte inlästa.',
  'ap.agent.tax.detail': 'Inlämning av skattemelding kräver Altinn-integration, som inte är ansluten ännu.',
  'ap.agent.tax.blocked': 'Saknar bokföringssiffror',
  'ap.agent.tax.titleDone': 'Skattemeldingen för {{year}} är inlämnad',
  'ap.agent.tax.title': 'Skatteunderlaget för {{year}} är beräknat',
  'ap.agent.tax.descEnk': 'Resultat före skatt: {{result}} kr. Enskilda näringsidkare beskattas hos ägaren.',
  'ap.agent.tax.desc': 'Resultat före skatt {{result}} kr ger {{tax}} kr i beräknad skatt.',
  'ap.agent.tax.action': 'Öppna skattemelding',
  'ap.agent.tax.lineResult': 'Resultat före skatt',
  'ap.agent.tax.lineTax': 'Beräknad skatt',
  'ap.agent.tax.lineLoss': 'Underskott att föra vidare',
  'ap.agent.annual.titleBlocked': 'Årsredovisningen är inte tillgänglig',
  'ap.agent.annual.descBlocked': 'Bokföringssiffrorna för {{year}} är inte inlästa.',
  'ap.agent.annual.blocked': 'Saknar bokföringssiffror',
  'ap.agent.annual.titleNotRequired': 'Företaget är inte skyldigt att upprätta årsredovisning',
  'ap.agent.annual.descNotRequired': 'Enskilda näringsidkare lämnar i stället näringsspesifikasjon med skattemeldingen.',
  'ap.agent.annual.action': 'Öppna årsredovisning',
  'ap.agent.annual.stepDocument': 'Årsredovisningsdokumentet',
  'ap.agent.annual.stepBoard': 'Styrelseprotokoll',
  'ap.agent.annual.stepAssembly': 'Bolagsstämmoprotokoll',
  'ap.agent.annual.stepSigned': 'Signering',
  'ap.agent.annual.titleDone': 'Årsredovisningen för {{year}} är inlämnad',
  'ap.agent.annual.title': '{{count}} steg återstår i årsredovisningen för {{year}}',
  'ap.agent.annual.titleReady': 'Årsredovisningen för {{year}} är klar för inlämning',
  'ap.agent.annual.descClosed': 'Räkenskapsåret är avslutat.',
  'ap.agent.annual.descOpen': 'Räkenskapsåret är inte avslutat ännu.',
  'ap.agent.annual.detail': 'Inlämning till Regnskapsregisteret kräver Altinn-integration, som inte är ansluten ännu.',
  'ap.agent.annual.line': 'Inte slutförd',
  'ap.execute.title': 'Bokför från AI-redovisningskonsult',
  'ap.execute.running': 'Bokför …',
  'ap.execute.warnTitleGeneric': 'Detta kan inte ångras',
  'ap.execute.warnTitle': 'Detta bokför i din bokföring',
  'ap.execute.warnBody': 'Verifikationerna bokförs som inköp med konto, moms och betalningssätt från verifikationsanalysen. Du ansvarar för att bokföringen är korrekt och måste makulera manuellt om något blir fel.',
  'ap.execute.checked': 'Plumme kontrollerar varje verifikation på nytt innan den bokförs. Verifikationer som inte håller måttet blir kvar i inkorgen med en motivering.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': '{{booked}} verifikationer bokförda',
  'ap.execute.partialCount': '{{done}} {{skipped}} utfördes inte och måste följas upp.',
  'ap.execute.failed': 'Bokföringen genomfördes inte.',
  'ap.lastRun': 'Senast genomgånget {{when}}',
  'ap.lastRunLabel': 'Senast genomgånget',
  'ap.bankDataHelp': 'SuperPlumma använder kontoutdragen som du har importerat under Bank. Direkt bankkoppling finns inte ännu — ladda upp kontoutdrag som XLSX eller CSV för att banktransaktionerna ska komma in.',
  'ap.bankData': 'Bankdata',
  'ap.bankStatementImported': 'Kontoutdrag importerat',
  'ap.noBankData': 'Inget kontoutdrag importerat',
  'ap.noData': 'Inga data',
  'ap.importBankStatement': 'Importera kontoutdrag',
  'ap.loadingTitle': 'Hämtar din bokföring …',
  'ap.loadingText': 'SuperPlumma väntar på data från din bokföring. Uppgiftslistan visas så snart siffrorna har lästs in.',
  'ap.disconnectBank': 'Koppla från bank',
  'ap.connected': 'Ansluten',
  'ap.noBankConnected': 'Ingen bank ansluten',
  'ap.connectBankHelp': 'Anslut din bank för att SuperPlumma ska kunna bokföra banktransaktioner.',
  'ap.bankIdNote': 'Anslutningen sker säkert med BankID.',
  'ap.missingBasis': 'Underlag saknas',
  'ap.rowDescMissing': 'Information saknas innan AI-redovisningskonsulten kan arbeta vidare.',
  'ap.rowBlockedReasonDefault': 'Kräver inställning eller data',
  'ap.rowOpen': 'Öppna',
  'ap.working': 'Arbetar …',
  'ap.execute.queued': 'Lagd i kö. Körs även om du stänger sidan – du får besked när den är klar.',
  'ap.execute.queueFailed': 'Det gick inte att lägga åtgärden i kö.',
  'ap.job.done': '{{booked}} utförda.',
  'ap.job.donePartial': '{{booked}} utförda · {{skipped}} utfördes inte och måste följas upp.',
  'ap.job.failed': 'Åtgärden genomfördes inte.',
  'ap.waiting': 'Väntar',
  'ap.waitingDetail': 'Kan inte behandlas ännu',
  'ap.waitingGroup.title': '{{count}} agenter väntar',
  'ap.waitingGroup.titleOne': '{{agent}} väntar',
  'ap.waitingGroup.detail': 'Blir aktuella när perioden är klar',
  'ap.oneLineNeedsControl': ' rad måste kontrolleras',
  'ap.manyLinesNeedControl': ' rader måste kontrolleras',
  'ap.readyHere': '{{count}} är klara',
  'ap.openWorklist': 'Öppna arbetslistan',
  'ap.controlWorklist': 'Kontrollera arbetslista',
  'ap.controlTask': 'Kontrollera',
  'ap.openPage': 'Öppna sida',
  'ap.waitsForPrevious': 'Väntar',
  'ap.nextStep': 'Nästa steg',
  'ap.comeBackLater': 'Kom tillbaka senare',
  'ap.solveBlocker': 'Lös blockering',
  'ap.getBankData': 'Hämta bankdata',
  'ap.approved': 'Godkänd',
  'ap.whichAgents': 'Vilka agenter vill du aktivera?',
  'ap.allAgents': 'Alla agenter',
  'ap.settings.enabledCount': '{{on}} av {{total}} på',
  'ap.settings.intro': 'SuperPlumma och agenterna arbetar löpande med din bokföring. Välj vilka agenter du vill ska hjälpa dig. Du kan när som helst ändra inställningarna senare. Arbete som inte är aktiverat måste du göra manuellt själv.',
  'ap.settings.allHelp': 'Aktivera eller inaktivera alla på en gång.',
  'ap.permission.inbox.label': 'Inkorgsagenten',
  'ap.permission.inbox.desc': 'Läser kvitton och fakturor som kommer in via e-post eller uppladdning och förbereder dem för bokföring.',
  'ap.permission.matching.label': 'Verifikationsagenten',
  'ap.permission.matching.desc': 'Kopplar verifikationer från inkorgen mot banktransaktioner som saknar dokumentation, när träffen är entydig.',
  'ap.permission.reconciliation.label': 'Avstämningsagenten',
  'ap.permission.reconciliation.desc': 'Ser till att varje avslutad månad faktiskt är avstämd och bokförd mot företagskontot.',
  'ap.permission.control.label': 'Kontrollagenten',
  'ap.permission.control.desc': 'Letar efter inköp utan verifikation och möjliga dubbelbokningar i bokföringen.',
  'ap.permission.asset.label': 'Tillgångsagenten',
  'ap.permission.asset.desc': 'Föreslår inventarier för större inköp. Du väljer kostnadsföring eller saldogrupp innan samma verifikation bokförs en gång.',
  'ap.permission.vendor.label': 'Leverantörsagenten',
  'ap.permission.vendor.desc': 'Skapar nya leverantörer när SuperPlumma upptäcker upprepade bokningar från samma leverantör.',
  'ap.permission.customer.label': 'Kundagenten',
  'ap.permission.customer.desc': 'Skapar nya kunder när SuperPlumma upptäcker försäljning till okända kunder.',
  'ap.permission.invoice.label': 'Fakturaagenten',
  'ap.permission.invoice.desc': 'Följer upp fakturautkast och färdiga fakturor som inte har skickats till kunden.',
  'ap.permission.dunning.label': 'Påminnelseagenten',
  'ap.permission.dunning.desc': 'Håller koll på förfallna fakturor och vad som bör påminnas om först.',
  'ap.permission.deadline.label': 'Fristagenten',
  'ap.permission.deadline.desc': 'Varnar för inlämningsfrister som närmar sig eller har passerats.',
  'ap.permission.mileage.label': 'Körjournalsagenten',
  'ap.permission.mileage.desc': 'Kontrollerar att tjänstekörning är förd med sträcka, syfte och kilometer, så att avdraget håller.',
  'ap.permission.vat.label': 'Momsagenten',
  'ap.permission.vat.desc': 'Stämmer av moms och förbereder MVA-meldingen för inlämning.',
  'ap.permission.tax.label': 'Skatteagenten',
  'ap.permission.tax.desc': 'Förifyller skattemeldingen baserat på din bokföring.',
  'ap.permission.payroll.label': 'Löneagenten',
  'ap.permission.payroll.desc': 'Håller koll på lönekörningar som väntar på godkännande. Beräkning och godkännande görs i lönevyn.',
  'ap.permission.annual.label': 'Årsredovisningsagenten',
  'ap.permission.annual.desc': 'Förbereder årsredovisning och noter vid bokslutet.',
  'ap.beta': 'Beta',
  'ap.heroTitle': 'SuperPlumma gör jobbet – du har kontrollen.',
  'ap.heroSub': 'Se vad som återstår, kontrollera förslag och godkänn nästa steg.',
  'ap.aboutHelp': 'SuperPlumma samlar uppgifter och förbereder förslag utifrån tillgängliga data. Bokföring och skickande kräver ditt godkännande. Reglaget styr den automatiska genomgången, inte inlämning eller betalning.',
  'ap.enabledDescription': 'SuperPlumma går igenom bokföringen varje morgon och samlar ihop det som väntar. Välj vilka områden agenterna ska titta på. Ingenting bokförs eller skickas utan att du godkänner det.',
  'ap.disabledDescription': 'Autopiloten är av. Slå på för att SuperPlumma ska se över bokföringen i bakgrunden.',
  'ap.monthOpenHelp': 'SuperPlumma förbereder förslag löpande under månaden. Vissa steg väntar tills perioden är klar, men allt uppdateras automatiskt när nytt underlag kommer in.',
  'ap.monthControl.label': 'Månadskontroll',
  'ap.monthControl.permissionDesc': 'Behandlar banktransaktioner, verifikationer, motparter och möjliga tillgångar och stämmer av månaden i ett samlat arbetsflöde.',
  'ap.monthControl.blockedDesc': 'Bankunderlaget saknas. Verifikationer utan banktransaktion kan fortfarande behandlas.',
  'ap.monthControl.actionableDesc': '{{count}} punkter återstår i {{period}}. Banktransaktioner, verifikationer, motparter, tillgångar och avstämning behandlas samlat.',
  'ap.monthControl.doneDesc': 'Månadskontrollen för {{period}} är genomgången.',
  'ap.monthControl.title': 'Månadskontroll för **{{period}}**',
  'ap.monthControl.detail': 'Behandla banktransaktioner kronologiskt, koppla verifikationer, skapa saknade motparter och bedöm möjliga tillgångar i samma arbetsyta. Godkännandet kan ångras; slutlig bokföring sker fortfarande med Stäm av och bokför.',
  'ap.monthControl.waitingDetail': 'Perioden pågår — nya rader kan fortfarande tillkomma',
  'ap.monthControl.blockedReason': 'Saknar kontoutdrag eller banktäckning',
  'ap.monthControl.action': 'Öppna månadskontroll',
  'ap.monthControl.findingsEmpty': 'Inga möjliga avvikelser.',
  'ap.monthControl.finding.deviation': 'Möjlig avvikelse',
  'ap.monthControl.finding.missingVoucher': 'Saknar verifikation',
  'ap.monthControl.finding.needsReview': 'Måste kontrolleras före avstämning.',
  'ap.monthControl.count.inboxOne': '{{count}} verifikation i inkorgen',
  'ap.monthControl.count.inboxMany': '{{count}} verifikationer i inkorgen',
  'ap.monthControl.count.bankMissingVoucherOne': '{{count}} bankrad utan verifikation',
  'ap.monthControl.count.bankMissingVoucherMany': '{{count}} bankrader utan verifikation',
  'ap.monthControl.count.bankLineOne': '{{count}} bankrad',
  'ap.monthControl.count.bankLineMany': '{{count}} bankrader',
  'ap.monthControl.count.reconciliationOne': '{{count}} avstämning',
  'ap.monthControl.count.reconciliationMany': '{{count}} avstämningar',
  'ap.monthControl.count.qualityOne': '{{count}} fynd i kvalitetskontrollen',
  'ap.monthControl.count.qualityMany': '{{count}} fynd i kvalitetskontrollen',
  'ap.monthControl.count.assetOne': '{{count}} tillgång',
  'ap.monthControl.count.assetMany': '{{count}} tillgångar',
  'ap.monthControl.count.supplierOne': '{{count}} leverantör',
  'ap.monthControl.count.supplierMany': '{{count}} leverantörer',
  'ap.monthControl.count.customerOne': '{{count}} kund',
  'ap.monthControl.count.customerMany': '{{count}} kunder',
  'ap.monthControl.count.itemOne': '{{count}} punkt',
  'ap.monthControl.count.itemMany': '{{count}} punkter',
  'ap.monthControl.noDate': 'Utan datum',
  'ap.monthControl.action.paySupplierInvoice': 'Betala leverantörsfaktura',
  'ap.monthControl.action.registerSupplierInvoice': 'Registrera leverantörsfaktura',
  'ap.monthControl.action.invoicePayment': 'Fakturabetalning',
  'ap.monthControl.action.registerSale': 'Registrera försäljning',
  'ap.monthControl.action.registerPurchase': 'Registrera inköp',
  'ap.monthControl.block.needsControl': 'Verifikationen måste kontrolleras före bokföring.',
  'ap.monthControl.block.missingBookingType': 'Saknar bokföringstyp.',
  'ap.monthControl.block.missingInvoiceNumber': 'Saknar fakturanummer.',
  'ap.monthControl.block.lowConfidence': 'Låg säkerhet i analysen.',
  'ap.monthControl.block.manualReview': 'Verifikationen kräver manuell kontroll.',
  'ap.monthControl.edit.purchase': 'Ändra inköp',
  'ap.monthControl.edit.sale': 'Ändra försäljning',
  'ap.monthControl.edit.bankFee': 'Ändra avgift',
  'ap.monthControl.edit.invoicePayment': 'Ändra fakturabetalning',
});
